import { useEffect } from 'react';

import { getSystemTypeConfig } from 'features/systems/config/system-type-registry';
import { SystemType } from 'features/systems/domain/models/system';

type UseSystemRefreshOnSuccessParams = {
  systemType: SystemType;
  updateSystemIsSuccess: boolean;
  refreshSystems: () => void;
};

const useSystemRefreshOnSuccess = ({ systemType, updateSystemIsSuccess, refreshSystems }: UseSystemRefreshOnSuccessParams): void => {
  const config = getSystemTypeConfig(systemType);
  const configurationHook = config.useConfiguration?.();
  const updateConfigurationIsSuccess = configurationHook?.updateConfigurationIsSuccess;

  useEffect(() => {
    if (updateSystemIsSuccess && (updateConfigurationIsSuccess === undefined || updateConfigurationIsSuccess)) {
      refreshSystems();
    }
  }, [updateSystemIsSuccess, updateConfigurationIsSuccess]);
};

export default useSystemRefreshOnSuccess;
